import {
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { FormPopupComponent } from '../../../../components';
import { CarrierFormComponent } from '../carrier-form/carrier-form.component';
import { CreateCarrierCommand, CarriersClient } from '@services';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'add-carrier-form',
    imports: [FormPopupComponent, CarrierFormComponent],
    templateUrl: './add-carrier-form.component.html',
})
export class AddCarrierFormComponent {
    @ViewChild(CarrierFormComponent, { static: false }) addNewForm: CarrierFormComponent;

    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onSave = new EventEmitter();

    private carrierClient = inject(CarriersClient);

    onPopupSaveClick = () => {
        let formData = this.addNewForm.getData();

        let createCommand = new CreateCarrierCommand({
            number: formData.number,
            status: formData.status,
            name: formData.name,
            scac: formData.scac,
            address: formData.address,
            phone: formData.phone,
            email: formData.email,
        });
        this.carrierClient.createCarrier(createCommand).subscribe({
            next: async () => {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.onSave.emit();
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg) => {
                    notify(
                        {
                            message: errMsg.message,
                            type: 'error',
                            displayTime: 5000,
                        },
                        {
                            position: 'bottom right',
                            direction: 'up-push',
                        },
                    );
                });
            },
        });
    };

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }
}
